// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 15.5C15 16.8181 16.02 17.8979 17.3138 17.9932L15.6732 23.1883L14.0112 22.7925C7.69338 21.2883 2.72113 16.3469 1.2157 10.0241L0.811523 8.32654L11.032 5.09903C11.0109 5.22958 11 5.36351 11 5.5C11 6.88071 12.1193 8 13.5 8C14.8807 8 16 6.88071 16 5.5C16 4.82089 15.7292 4.20502 15.2897 3.75447L22.5325 1.46729L18.7795 13.3518C18.4052 13.1284 17.9676 13 17.5 13C16.1193 13 15 14.1193 15 15.5ZM9.5 15C10.8807 15 12 13.8807 12 12.5C12 11.1193 10.8807 10 9.5 10C8.11929 10 7 11.1193 7 12.5C7 13.8807 8.11929 15 9.5 15Z"}}]};

const CheeseFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cheese-filled',
    ref,
    icon: element,
  },
));

CheeseFilledIcon.displayName = 'CheeseFilledIcon';

export default CheeseFilledIcon;
